import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/AppSidebar';
import { ImpersonationBanner } from '@/components/ImpersonationBanner';

interface AppLayoutProps {
  children: ReactNode;
}

// Routes that should NOT have sidebar
const NO_SIDEBAR_ROUTES = ['/auth', '/presentation', '/sales-presentation'];

export function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  const showSidebar = !NO_SIDEBAR_ROUTES.some(route => location.pathname.startsWith(route));

  if (!showSidebar) {
    // For routes without sidebar, don't render SidebarProvider at all
    return <>{children}</>;
  }

  // Always render SidebarProvider for routes with sidebar to persist state
  // This ensures smart collapse state and sidebar preferences are maintained
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <SidebarInset className="flex-1">
          <ImpersonationBanner />
          {children}
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}

